
import { defineComponent } from "vue";

export default defineComponent({
  name: "DhTableColumn",
  setup() {
    return {};
  },
});
